import { getDefaultConfig } from '../base.js';

const envConfig = {
    subDomain: undefined,
    rootDomain: 'poker.fanduel.com',
    internalNamespace: 'web-fanduel-poker-use1',
    applicationKey: 'bWVuZWFpdG8=',
    siftBeaconKey: '836af332f2',
    landingPageUrl: 'https://cdn.poker.fanduel.com/landing-page/index.html',
    apis: {
        AmplitudeExperimentClient: {
            apiKey: 'server-t8LQgdvqM94XjlSWDNStiPCcPIa1RJSw'
        },
        BanneringToolClient: {
            host: 'casino-bannering-tool.casino.fanduel.com'
        },
        TransactionHistory: {
            baseUrl: 'https://api.statePlaceholder.poker.fanduel.com'
        },
        CppClient: {
            baseUrl: 'https://promos-api.poker.fanduel.com',
            placementQueryConfig: {
                brand: 'FANDUEL_USA'
            }
        },
        SiteWideJackpotClient: {
            host: 'api.statePlaceholder.poker.fanduel.com'
        },
        MdsClient: {
            baseUrl: 'mds.statePlaceholder.poker.fanduel.com'
        },
        CasinoSearchClient: {
            host: 'casino-search.casino.fndlext.net',
            headers: {
                'x-api-key': 'Id5JOd8AhY4OkkcCICr7c4fGGMdj8UDB7VIN1Ocv'
            }
        }
    },
    services: {
        amplitudeKey: '38d701cfaeefd9c582700b62c44c03d7',
        braze: {
            key: 'c895a012-65bd-4f10-9fd9-98897b643e72',
            product: 'FD-POKER'
        },
        snowplow: {
            appId: 'casino-web',
            androidAppId: 'poker-android',
            trackerUrl: 'partner.sp.prd.use1.data.fndlext.net'
        }
    },
    unifiedModules: {
        env: 'prod',
        clientId: 'f0844edfd693986422850f418c43e035',
        pxEnabled: true
    },
    perimeterx: {
        appId: 'JMCVuBG8'
    },
    debug: {
        hideDebugMenu: true
    },
    seo: {
        noIndex: false,
        sitemap: true
    }
};

export const config = getDefaultConfig(envConfig);
